import PageHero from "../components/PageHero";
import synergies from "../data/synergies";

function ClientsAndSynergies() {
  return (
    <main>
      <PageHero
        title="Clients & Synergies"
        text="Our work grows through trusted collaborations, strong partnerships and long-term synergies across Europe."
      />

      <section className="section split">
        <div>
          <span className="eyebrow">Partners</span>
          <h2>Meet our partners, clients and wider collaboration network.</h2>
        </div>

        <p>
          R&Do team is formed by Senior Developers and Web designers and is well known
          for their high quality work and forward thinking. The company aims to the
          continuous development and commercialisation of innovative ideas in the form
          of products and services, mainly based on ICT.
        </p>
      </section>

      <section className="section synergies-section">
        <div className="synergies-list">
          {synergies.map((synergy) => (
            <article className="synergy-row" key={synergy.name}>
              <a
                className="synergy-logo"
                href={synergy.url}
                target="_blank"
                rel="noreferrer"
                aria-label={`Visit ${synergy.name} website`}
              >
                <img src={synergy.image} alt={synergy.name} />
              </a>

              <div className="synergy-content">
                <h2>
                  <a href={synergy.url} target="_blank" rel="noreferrer">
                    {synergy.name}
                  </a>
                </h2>

                <p>{synergy.description}</p>

                <a
                  className="synergy-link"
                  href={synergy.url}
                  target="_blank"
                  rel="noreferrer"
                >
                  Visit website
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section cards three">
        <article className="card">
          <h3>Strategic partnerships</h3>

          <p>
            We collaborate with organisations, institutions and project consortia to turn
            research outcomes into visible and usable results.
          </p>
        </article>

        <article className="card">
          <h3>European networks</h3>

          <p>
            Our synergies connect digital innovation, vocational training, green economy,
            blue economy and communication expertise.
          </p>
        </article>

        <article className="card">
          <h3>Long-term value</h3>

          <p>
            We build relationships that outlive deliverables — because real impact is not
            a checkbox, it is a chain reaction.
          </p>
        </article>
      </section>
    </main>
  );
}

export default ClientsAndSynergies;